import * as S from './styled';
import { useTranslation } from 'react-i18next';

export function Footer() {
  const { t } = useTranslation();

  return (
    <S.FooterStyled>
      <S.FooterImageStyled>
        <img src={`${process.env.PUBLIC_URL}/images/footer/main.png`} alt="/images/footer/main.png" />
      </S.FooterImageStyled>

      <S.FooterContentStyled>
        <div className="message">
          {t('footer.text_1')}
          <br />
          {t('footer.text_2')}
        </div>

        <S.FooterContactStyled>
          <img
            src={`${process.env.PUBLIC_URL}/images/footer/fb.png`}
            alt="/images/footer/fb.png"
            onClick={() => window.open('https://www.facebook.com/bap32', '_blank', 'noopener,noreferrer')}
          />
          <img
            src={`${process.env.PUBLIC_URL}/images/footer/tw.png`}
            alt="/images/footer/tw.png"
            onClick={() => window.open('https://www.facebook.com/bap32', '_blank', 'noopener,noreferrer')}
          />
          <img
            src={`${process.env.PUBLIC_URL}/images/footer/ins.png`}
            alt="/images/footer/ins.png"
            onClick={() => window.open('https://www.facebook.com/bap32', '_blank', 'noopener,noreferrer')}
          />
        </S.FooterContactStyled>
      </S.FooterContentStyled>
    </S.FooterStyled>
  );
}
